import { IMAGE, VIDEO, AUDIO, FONT, OTHER, HEIC, PDF } from './fileTypes';

export default {
  [IMAGE]: 'image',
  [HEIC]: 'apple',
  [VIDEO]: 'projects',
  [AUDIO]: 'audio',
  [FONT]: 'typography',
  [PDF]: 'pdf',
  [OTHER]: 'document'
};